//*** Lib */

import { createCookie, getCookie, isCookieExist, removeCookie, setCookie } from "../utils/Cookies/CookieHandler";
import { removeData } from "../utils/LocalStorage/LocalStorageManager";
const authCookieName = 'AuthUser';
const tokenCookieName = 'Token';

export const setAuthProps = (data) => {
    const authProps = {
        cookieName: authCookieName,
        cookieValue: data,
        expirationTime: data.sessionTimeout
    }
    createCookie(authProps);
    setTokenProps(data.token);
}

export const getAuthProps = () => {
    return getCookie(authCookieName);
}

export const isAuthorized = () => {
    return isCookieExist(authCookieName);
}

export const setTokenProps = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookie(tokenProps);
}

export const getTokenProps = () => {
    return getCookie(tokenCookieName);
}

export const signOut = () => {
    // removeAllCookies();
    removeCookie(authCookieName);
    removeCookie(tokenCookieName);
    removeData("viewType");
    window.location.href = "/login";
}

export const IsAuthorizeUser = (allowUserType) => {
    let cookie = getAuthProps();
    let roles = cookie?.roles;
    // let roleType = cookie && cookie["roleId"] ? Number(cookie["roleId"]) : 0;
    let roleType = roles?.roleName;
    if (allowUserType !== undefined) {
        return allowUserType.some((item)=>item === roleType)
        // return allowUserType.find(x => x === roleType)
    }
    return false
}
